import { render } from "./ModalAddInfoSupplierl.vue?vue&type=template&id=6f61a30d"
import script from "./ModalAddInfoSupplierl.vue?vue&type=script&lang=js"
export * from "./ModalAddInfoSupplierl.vue?vue&type=script&lang=js"

import "./ModalAddInfoSupplierl.vue?vue&type=style&index=0&id=6f61a30d&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__